import { useEffect, useState } from 'react';
import { getOSByUserAgent } from '@toss/utils';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useRouter } from 'next/router';
import { useScrollYPosition } from '@/hooks/useScrollYPosition';
import { ArrowUpIcon } from '@/icons';
import { useIsInGoogleClassroom } from '@/shared/googleClassroom';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
export const ScrollAssistButton = () => {
  const [visible, setVisible] = useState(false);
  const scrollY = useScrollYPosition(300);
  const inGoogleClassroom = useIsInGoogleClassroom();
  const router = useRouter();
  const isShowChannelTalk = !inGoogleClassroom && !router.pathname.startsWith('/admin');
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const userAgent = getOSByUserAgent();
  const isWeb = userAgent === 'web';
  useEffect(() => {
    if (scrollY > 500) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [scrollY]);
  const CHANNEL_TALK_STYLE = {
    WEB: {
      BOTTOM: 25,
      RIGHT: 25,
      HEIGHT: 56
    },
    MOBILE: {
      BOTTOM: 70,
      RIGHT: 14,
      HEIGHT: 44
    }
  };
  const bottom = (() => {
    const GAP = isWeb ? 12 : 8;
    if (isShowChannelTalk) {
      return isWeb ? CHANNEL_TALK_STYLE.WEB.BOTTOM + CHANNEL_TALK_STYLE.WEB.HEIGHT + GAP : CHANNEL_TALK_STYLE.MOBILE.BOTTOM + CHANNEL_TALK_STYLE.MOBILE.HEIGHT + GAP;
    }
    return isWeb ? CHANNEL_TALK_STYLE.WEB.BOTTOM : CHANNEL_TALK_STYLE.MOBILE.BOTTOM;
  })();
  if (!visible) return null;
  return <Button onClick={scrollToTop} className={cn(isWeb ? 'size-[56px]' : 'size-[44px] min-w-[44px]', 'fixed z-channelTalk hover:bg-default rounded-lg border-assistive bg-default p-[10px] shadow-md')} intent={'alternative'} style={{
    right: isWeb ? CHANNEL_TALK_STYLE.WEB.RIGHT : CHANNEL_TALK_STYLE.MOBILE.RIGHT,
    bottom
  }} data-sentry-element="Button" data-sentry-component="ScrollAssistButton" data-sentry-source-file="ScrollAssistButton.tsx">
      <ArrowUpIcon fill={ICON_COLOR.default} size={'md'} data-sentry-element="ArrowUpIcon" data-sentry-source-file="ScrollAssistButton.tsx" />
    </Button>;
};